<template>
    <BlocksAnimation class="pb-16 lg:py-16">
        <div
            class="space-y-3 mb-9"
            :class="{
                'container mx-auto text-center': block.HeadingAndTextAlignment === 'centred'
            }"
        >
            <p class="text-subheading text-base leading-base font-ux font-semibold uppercase">{{block.Subheading}}</p>
            <h2 class="text-heading text-4xl leading-4xl font-brand-primary font-semibold">{{block.Heading}}</h2>
            <p class="text-body text-base leading-base font-ux !mt-4 whitespace-pre-wrap">{{block.BodyText}}</p>
        </div>

        <div
            class="flex flex-col space-y-7 lg:flex-row items-stretch lg:space-y-0 lg:gap-12"
            :class="{
                'lg:flex-row-reverse': block.ImagePlacement === 'right'
            }"
        >
            <div ref="accordionImage" class="hidden lg:block w-full max-w-[550px] min-h-[380px] max-h-[220px] lg:max-h-[800px] relative">
                <Image
                    v-for="(item, itemIndex) in block.AccordionItems"
                    :key="`${itemIndex}-image`"
                    :image="item?.imageAndTextAccordionItem_Image[0] ?? block.DefaultImage"
                    class="!absolute inset-0 transition-opacity duration-300 radius-image-base"
                    :class="{
                        'opacity-0': activeItemId !== item.id,
                        'opacity-100': activeItemId === item.id,
                    }"
                />

                <!-- Default image -->
                <Image
                    :image="block.DefaultImage"
                    class="!absolute inset-0 transition-opacity duration-300 radius-image-base"
                    :class="{
                        'opacity-0': activeItemId,
                        'opacity-100': !activeItemId,
                    }"
                />
            </div>

            <div class="flex-1 divide-y divide-[--border-base]">
                <div class="flex flex-col">
                    <!-- loop -->
                    <AccordionItem
                        v-for="(item, itemIndex) in block.AccordionItems"
                        :id="item.id"
                        :key="itemIndex"
                        :icon="item?.imageAndTextAccordionItem_Icon"
                        :title="item.imageAndTextAccordionItem_Heading"
                        :accordion-style="block.AccordionStyle"
                        :active-id="activeItemId"
                        @toggle-active="handleToggle"
                    >
                        <div class="flex flex-col w-full">
                            <p class="text-body text-base leading-base font-ux">
                                {{item.imageAndTextAccordionItem_BodyText}}
                            </p>

                            <NuxtLink
                                v-if="item.imageAndTextAccordionItem_Button.length > 0"
                                :to="item.imageAndTextAccordionItem_Button[0].url"
                                :target="item.imageAndTextAccordionItem_Button[0].target"
                                class="mt-2"
                            >
                                <DButton size="lg" :theme="buttonTheme(item.imageAndTextAccordionItem_Button[0].buttonStyle)">
                                    {{ item.imageAndTextAccordionItem_Button[0].text }}
                                </DButton>
                            </NuxtLink>

                            <div
                                class="aspect-video w-full block lg:hidden mt-4 bg-cover bg-center radius-image-base"
                                :style="{
                                    backgroundImage: `url(${item?.imageAndTextAccordionItem_Image[0]?.url ?? block.DefaultImage[0]?.url})`
                                }"
                            />
                        </div>
                    </AccordionItem>
                </div>
            </div>
        </div>
    </BlocksAnimation>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    // grab item from accordion block

    const { buttonTheme } = useButtonTheme()

    const props = defineProps({
        block: Object
    })

    const accordionImage = ref(null)

    const activeItemId = ref(get(props.block, 'AccordionItems.0.id'))

    const handleToggle = (id) => {
        activeItemId.value = id
    }

    onMounted(() => {
        // check after initial animation
        delay(() => {
            if (!accordionImage.value) {
                return
            }
            accordionImage.value.style.height = accordionImage.value.offsetHeight + 'px'
        }, 500)
    })
</script>

<style lang="scss" scoped>

</style>
